import { loadStripe } from '@stripe/stripe-js/pure';
import type { Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useCallback, useState, type ReactNode } from 'react';
import { StripeLoaderContext } from './stripeLoader';

// L'entrée par défaut de @stripe/stripe-js charge Stripe.js dès l'import, sur toutes les pages :
// sur le live, Stripe recevait alors l'URL du spectateur, qui porte son jeton. Ici, Stripe.js
// n'est chargé qu'à l'affichage d'un formulaire de paiement ou au moment de payer.
let stripePromise: Promise<Stripe | null> | null = null;

function getStripe() {
  stripePromise ??= loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? '');
  return stripePromise;
}

export function StripeProvider({ children }: { children: ReactNode }) {
  const [elementsStripe, setElementsStripe] = useState<Promise<Stripe | null> | null>(null);

  const ensureStripe = useCallback(() => {
    const promise = getStripe();
    setElementsStripe(promise);
    return promise;
  }, []);

  return (
    <StripeLoaderContext.Provider value={ensureStripe}>
      <Elements stripe={elementsStripe}>{children}</Elements>
    </StripeLoaderContext.Provider>
  );
}
